import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=2e51ad66&scoped=true&"
import script from "./Instruction.vue?vue&type=script&lang=ts&"
export * from "./Instruction.vue?vue&type=script&lang=ts&"
import style0 from "./Instruction.vue?vue&type=style&index=0&id=2e51ad66&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e51ad66",
  null
  
)

export default component.exports